/**
 * Get time in seconds. Can be used for getting the current time for fields like created or modified
 */
export default function getTimeInSeconds() {
    return Math.round(Date.now() / 1000);
}
